// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import OrganisationRequestSchema from './organisation-request-schema';
import UserRequestSchema from './user-request-schema';

const schema = {
  $id: '/post-organisation-request-schema',
  type: 'object',
  required: ['eventIdentifier'],
  properties: {
    organisation: {
      ...OrganisationRequestSchema,
    },
    user: {
      ...UserRequestSchema,
    },
    eventIdentifier: {
      type: 'string',
      format: 'uuid',
    },
    existingOrganisationId: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
